import { render, staticRenderFns } from "./InternationalTopUp.vue?vue&type=template&id=276f1779&"
import script from "./InternationalTopUp.vue?vue&type=script&lang=js&"
export * from "./InternationalTopUp.vue?vue&type=script&lang=js&"
import style0 from "./InternationalTopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports